import React from 'react';
import { bool, shape, string } from 'prop-types';

const InfoCircleColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.00065 1.3335C4.32065 1.3335 1.33398 4.32016 1.33398 8.00016C1.33398 11.6802 4.32065 14.6668 8.00065 14.6668C11.6807 14.6668 14.6673 11.6802 14.6673 8.00016C14.6673 4.32016 11.6807 1.3335 8.00065 1.3335ZM7.33398 4.66683V6.00016H8.66732V4.66683H7.33398ZM7.33398 7.3335V11.3335H8.66732V7.3335H7.33398ZM2.66732 8.00016C2.66732 10.9402 5.06065 13.3335 8.00065 13.3335C10.9407 13.3335 13.334 10.9402 13.334 8.00016C13.334 5.06016 10.9407 2.66683 8.00065 2.66683C5.06065 2.66683 2.66732 5.06016 2.66732 8.00016Z" fill="currentColor" />
  </svg>
);

InfoCircleColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default InfoCircleColor;
